/**
 * 联网搜索组件
 * zxw
 * 创建时间：2026-01-20
 */


import {
    Button,
    Space,
    Skeleton,
    Row,
    Col,
} from 'antd';
import {
    SearchOutlined,
    RightOutlined,
} from '@ant-design/icons';

const NetworkSearch = props => {
    const { children, title, streamStatus } = props;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Node active={true}>
            <span style={{ color: '#bfbfbf' }}>搜索中···</span>
        </Skeleton.Node>
    }

    // 深度提取所有文本内容
    const extractTextFromReactElement = (element) => {
        if (!element) return '';

        // 处理字符串：返回原字符串
        if (typeof element === 'string') {
            return element;
        }

        // 处理 react.element：获取元素的href
        if (element.props) {
            // 如果有href属性，返回href值（对于链接）
            if (element.props.href) {
                return element.props.href;
            }

            // 递归处理子元素
            if (element.props.children) {
                if (Array.isArray(element.props.children)) {
                    return element.props.children.map(child =>
                        extractTextFromReactElement(child)
                    ).join('');
                }
                return extractTextFromReactElement(element.props.children);
            }
        }

        return String(element);
    };

    // 将 children 转换为纯文本
    const getChildrenAsText = () => {
        if (typeof children === 'string') {
            return children;
        }

        if (Array.isArray(children)) {
            return children.map(child =>
                extractTextFromReactElement(child)
            ).join('');
        }

        return extractTextFromReactElement(children);
    };

    // 从混合文本中提取JSON部分
    const extractJsonFromMixedText = (text) => {
        // 尝试直接解析整个文本
        try {
            const parsed = JSON.parse(text);
            return parsed;
        } catch (e) {
            // 查找第一个'['和最后一个']'之间的内容
            const firstBracket = text.indexOf('[');
            const lastBracket = text.lastIndexOf(']');

            if (firstBracket >= 0 && lastBracket > firstBracket) {
                const jsonPart = text.substring(firstBracket, lastBracket + 1);

                try {
                    return JSON.parse(jsonPart);
                } catch (parseError) {
                    console.error("JSON提取失败:", parseError);
                }
            }

            return [];
        }
    };

    let searchData = [];
    let originalText = '';

    try {
        // 获取 children 的纯文本
        originalText = getChildrenAsText();

        // 转换为JSON
        searchData = extractJsonFromMixedText(originalText);

        // 确保数据格式正确
        if (!Array.isArray(searchData)) {
            searchData = [];
        }
    } catch (error) {
        console.error("处理children时出错:", error);
        searchData = [];
    }

    // 格式化URL（确保有协议）
    const formattedData = searchData.map(item => {
        if (item.link && !item.link.startsWith('http')) {
            return {
                ...item,
                link: `https://${item.link.replace(/^www\./, '')}`
            };
        }
        return item;
    });

    if (formattedData.length === 0) return null;

    return <div style={{ marginBottom: 8 }}>
        <Button
            icon={<><SearchOutlined style={{ marginRight: 8 }} /><span>搜索 ：</span></>}
            size='large'
            variant='outlined'
            style={{ fontSize: 13, color: 'rgba(0,0,0,.25)', width: '100%', }}
            onClick={() => {
                props.setOpenNetworkSource(true);
                props.setNetworkSourceData(formattedData);
            }}
        >
            <Row style={{ width: '100%', textAlign: 'left' }}>
                <Col span={21} style={{ lineHeight: '25px', fontSize: 13, }}>{title}</Col>
                <Col span={3}>
                    <Space vertical style={{ fontSize: 13, }} >
                        <Space.Compact style={{ lineHeight: '25px' }}>
                            <span style={{ marginRight: 8 }}>{formattedData.length} 个结果</span>
                            <RightOutlined />
                        </Space.Compact>
                    </Space>
                </Col>
            </Row>
        </Button>
    </div>
}

export default NetworkSearch;